<template>
  <app-table
      :selectable="!regexType"
      :selected-rows="checkedRows"
      :deletable="!regexType"
      :copyable="!regexType"
      :editable="!regexType"
      :data="items"
      :page-size="params.limit"
      :highlight-rows-on-hover="true"
      @deleteRow="deleteItem"
      @updatedRow="fetchPairingTemplates(false)"
      :loading="pending"
      @rowSelect="selectRow"
  >
    <template slot="secondary_header" v-if="!regexType">
      <search-bar
        :params="params"
        @update="fetchPairingTemplates(true)"
        :create-disabled="pending || pendingCreate"
      />
    </template>
    <app-table-column v-if="!regexType" first sort-name="epgSource" :label="translations.epgSourceTvStation">
      <template slot-scope="row">
        <div v-html="row.epgSource" v-if="row.type === 'PAIRING_TEMPLATE_CONTENT_ID_TYPE' ||
        row.type === 'PAIRING_TEMPLATE_REGEX_NAME_TYPE'" />
        <div v-html="row.tvStation" v-if="row.type === 'PAIRING_TEMPLATE_BROADCAST_TYPE'" />
      </template>
    </app-table-column>
    <app-table-column :label="translations.regex">
      <template slot-scope="row">
        <div>
          {{row.expression}}
        </div>
      </template>
    </app-table-column>
    <app-table-column v-if="regexType" attribute="epgSource" :label="translations.epgSource" />
    <app-table-column :label="translations.extraCriteria">
      <template slot-scope="row">
        <div>
          {{row.extraCriteria}}
        </div>
      </template>
    </app-table-column>
    <app-table-column attribute="totalPairingHits" :label="translations.totalPairingHits" />
    <app-table-column attribute="lastPairingHits" :label="translations.lastPairingHits" />
    <app-table-column sort-name="lastPairingHitDate" :label="translations.lastPairingHitDate">
      <template slot-scope="row">
        <div v-html="formatDate(row.lastPairingHitDate)" />
      </template>
    </app-table-column>

    <template slot="footer">
      <p class="check_all">
        <app-checkbox
            checkboxId="check-all"
            name="check-all"
            :checked="hasSelectedAll"
            @change="selectAll"
        />
        <app-button @click="deletePairingTemplates" v-translate>Smazat</app-button>
      </p>
      <app-table-pagination
        v-if="itemsMetadata.totalCount > params.limit"
        :page="listPage"
        :itemsPerPage="params.limit"
        :totalCount="itemsMetadata.totalCount"
        @pageChanged="tablePageChanged"
      />
    </template>
  </app-table>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SearchBar from 'components/Templates/SearchBar'
import { isNilOrEmpty } from 'ramda-adjunct'
import { showErrorWithTimeout } from '../../../utils/form'
import { showDeleteDialog } from '../../../utils/dialog'
import formatDateMixin from '../../../mixins/formatDateMixin'
import getItemsListMixin from 'mixins/getItemsListMixin'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'PairingTemplates',
  preventFetchOnCreated: true
})

export default {
  name: 'templates',
  components: {
    SearchBar
  },
  mixins: [
    formatDateMixin,
    itemsListMixin
  ],
  props: {
    regexType: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.params.show = this.regexType ? null : this.$route.params.id
    this.fetchPairingTemplates(false)
    this.getEpgSources({
      params: {
        order: 'name'
      }
    })
    this.getAllTvStations()
  },
  data() {
    return {
      checkedRows: [],
      listPage: 1
    }
  },
  computed: {
    ...mapState({
      pendingCreate: state => state.pairingTemplates.pending.pairingTemplate,
      items: state => state.pairingTemplates.pairingTemplates,
      itemsMetadata: state => state.pairingTemplates.pairingTemplatesMetadata,
      pending: state => state.pairingTemplates.pending.pairingTemplates
    }),
    hasSelectedAll() {
      return (
          this.checkedRows.length > 0 &&
          this.items.every(v => this.checkedRows.includes(v._id))
      )
    },
    translations() {
      return {
        broadcastNameContentId: this.$gettext('Název vysílání/obsahu'),
        epgSourceTvStation: this.$gettext('Zdroj EPG/Tv stanice'),
        epgSource: this.$gettext('Zdroj EPG'),
        regex: this.$gettext('Regulární výraz'),
        extraCriteria: this.$gettext('Extra kritéria'),
        totalPairingHits: this.$gettext('Hitů celkem'),
        lastPairingHits: this.$gettext('Počet posledních hitů'),
        lastPairingHitDate: this.$gettext('Datum posledního hitu'),
        type: this.$gettext('Typ párovací šablony'),
        episodeType: this.$gettext('Podle názvu epizody'),
        broadcastType: this.$gettext('Podle názvu vysílání')
      }
    },
    listLoading() {
      return this.pending && isNilOrEmpty(this.items)
    }
  },
  methods: {
    ...mapActions([
      'getPairingTemplates',
      'deletePairingTemplate',
      'deletePairingTemplates',
      'createPairingTemplate',
      'getAllTvStations',
      'getEpgSources'
    ]),
    shouldRefreshAfterDelete() {
      return true
    },
    selectRow(row, checked) {
      if (checked) {
        this.checkedRows.push(row._id)
      } else {
        const index = this.checkedRows.indexOf(row._id)
        if (index !== -1) {
          this.checkedRows.splice(index, 1)
        }
      }
    },
    deletePairingTemplates() {
      showDeleteDialog(this, {
        apiMethod: 'deletePairingTemplates',
        params: {
          ids: this.checkedRows
        },
        shouldRefresh: true,
        refresh: {
          apiMethod: 'getPairingTemplates',
          params: this.params
        }
      }, this.getDeleteMessage())
    },
    selectAll(checked) {
      if (checked) {
        this.items.forEach(v => {
          if (this.checkedRows.indexOf(v._id) === -1) {
            this.checkedRows.push(v._id)
          }
        })
      } else {
        this.checkedRows = []
      }
    },
    deleteItem(item) {
      const deleteError = this.getDeleteError(item)
      if (deleteError) {
        showErrorWithTimeout(this, deleteError)
      } else {
        showDeleteDialog(this, {
          apiMethod: 'deletePairingTemplate',
          params: {
            id: item._id
          }
        }, this.getDeleteMessage(item))
      }
    },
    getDeleteError() {
      return null
    },
    getDeleteMessage() {
      return null
    },
    fetchPairingTemplates(resetPage) {
      if (resetPage && this.listPage !== 1) {
        this.tablePageChanged(1, false)
        return
      }
      this.getPairingTemplates({ params: this.params })
    },
    tablePageChanged(page, fetchItems = true) {
      this.listPage = page
      this.checkedRows = []
      this.params.offset = (this.listPage - 1) * this.params.limit
      if (fetchItems) {
        this.fetchPairingTemplates(false)
      }
    }
  }
}
</script>
